import type { SlotLocation } from '../types';

export function locationsEqual(a: SlotLocation, b: SlotLocation): boolean {
  if (a.section !== b.section) return false;
  if (a.section === 'equipment' && b.section === 'equipment') return a.key === b.key;
  if (a.section !== 'equipment' && b.section !== 'equipment') return a.index === b.index;
  return false;
}
